import { Group, Text, Tooltip } from '@mantine/core';
import { IconHelpCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export default function AmountToApplyLabel() {
  const { t } = useTranslation(['FieldName']);

  return (
    <Group gap={4}>
      <Text component="span" size="sm" fw={500}>
        {t('FieldName:amountToApply')}
      </Text>
      <Tooltip label={t('FieldName:amountToApplyHelp')} withArrow>
        <IconHelpCircle size={16} color="var(--mantine-color-dimmed)" />
      </Tooltip>
    </Group>
  );
}
